// extracted by mini-css-extract-plugin
export default {"roof_container":"Roof_roof_container__h9QVZ","roof":"Roof_roof__4-xHk","roof_lottie":"Roof_roof_lottie__S6FaH","pp_button_lottie":"Roof_pp_button_lottie__T+loF"};